// JSON Import/Export Utilities for Admin Panel

export const exportToJSON = (data, filename) => {
  try {
    const jsonString = JSON.stringify(data, null, 2);
    const blob = new Blob([jsonString], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    
    const link = document.createElement('a');
    link.href = url;
    link.download = `${filename}.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    
    return { success: true, message: `${filename}.json downloaded successfully` };
  } catch (error) {
    return { success: false, message: `Export failed: ${error.message}` };
  }
};

export const importFromJSON = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    
    reader.onload = (e) => {
      try {
        const jsonData = JSON.parse(e.target.result);
        resolve({ success: true, data: jsonData, message: 'JSON imported successfully' });
      } catch (error) {
        resolve({ success: false, data: null, message: `Invalid JSON: ${error.message}` });
      }
    };
    
    reader.onerror = () => {
      resolve({ success: false, data: null, message: 'Failed to read file' });
    };
    
    reader.readAsText(file);
  });
};

export const validateJSONData = (data, category) => {
  const validators = {
    personalInfo: (data) => {
      return data && typeof data === 'object' && 
             typeof data.name === 'string' && 
             typeof data.title === 'string';
    },
    contactInfo: (data) => {
      return data && typeof data === 'object' && 
             typeof data.email === 'string' && 
             typeof data.phone === 'string';
    },
    experience: (data) => {
      return Array.isArray(data) && data.every(exp => 
        exp && typeof exp === 'object' && 
        typeof exp.title === 'string' && 
        typeof exp.company === 'string'
      );
    },
    education: (data) => {
      return Array.isArray(data) && data.every(edu => 
        edu && typeof edu === 'object' && 
        typeof edu.degree === 'string' && 
        typeof edu.institution === 'string'
      );
    },
    patents: (data) => {
      return Array.isArray(data) && data.every(patent => 
        patent && typeof patent === 'object' && 
        typeof patent.title === 'string' && 
        typeof patent.number === 'string'
      );
    },
    mainMedia: (data) => {
      return Array.isArray(data) && data.every(media => 
        media && typeof media === 'object' && 
        typeof media.title === 'string' && 
        typeof media.src === 'string'
      );
    }
  };
  
  const validator = validators[category];
  if (!validator) {
    return { valid: false, message: `Unknown category: ${category}` };
  }
  
  if (!validator(data)) {
    return { valid: false, message: `Invalid data structure for ${category}` };
  }
  
  return { valid: true, message: 'Data is valid' };
};

export const getCategoryFilename = (category) => {
  const filenames = {
    personalInfo: 'personal-info',
    contactInfo: 'contact-info',
    experience: 'experience',
    education: 'education',
    patents: 'patents',
    mainMedia: 'media-gallery'
  };
  return filenames[category] || category;
};

export const getCategoryDisplayName = (category) => {
  const displayNames = {
    personalInfo: 'Personal Information',
    contactInfo: 'Contact Information',
    experience: 'Experience',
    education: 'Education',
    patents: 'Patents',
    mainMedia: 'Media Gallery'
  };
  return displayNames[category] || category;
};
